import { render, staticRenderFns } from "./distribution.vue?vue&type=template&id=8bba77bc&scoped=true&"
import script from "./distribution.vue?vue&type=script&lang=js&"
export * from "./distribution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bba77bc",
  null
  
)

export default component.exports